import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";

import VTlist from "./VTlist";
import VTcontent from "./VTcontent";

import "./VerticalTab.css";

function VerticalTab(props) {
  const [activeTabId, setActiveTabId] = useState(0);

  function btnClick(id) {
    setActiveTabId(id);
  }

  return (
    <Container className="section__Jobs-container">
      <Row>
        <Col sm="4">
          <div className="section__Jobs-styledTab">
            <ul className="section__Jobs-styledTabList">
              {props.data.map((job, index) => (
                <VTlist
                  key={index}
                  onClick={btnClick}
                  data={job}
                  index={index}
                  activeTabId={activeTabId}
                />
              ))}
            </ul>
          </div>
        </Col>
        <Col sm="8">
          {props.data.map((job, index) => (
            <VTcontent
              data={job}
              key={index}
              index={index}
              activeTabId={activeTabId}
            />
          ))}
        </Col>
      </Row>
      <span
        className={
          activeTabId === 0
            ? "index1-chosen"
            : activeTabId === 1
            ? "index2-chosen"
            : "index3-chosen"
           
        }
      >
        &nbsp;
      </span>
    </Container>
  );
}

export default VerticalTab;
